<template>
    <form-container header-text="Mitglied endgültig löschen" :width="450" :action="action"
                    :valid-actions="['loeschen']"
                    header-icon="mdi-card-account-details" @save="save"
                    button-ok="Ja" button-cancel="Nein"
                    buttonOkColor="primary">
        <v-card-text class="px-6" v-if="actionObject">
            <p>Möchtest du Mitglied <span class="font-weight-bold primary--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span>
            (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
            wirklich endgültig und unwiderruflich aus dem System löschen?</p>
            <!--<p>Falls ja, gib bitte die Passnummer in das folgende Feld ein und klicke auf 'JA':</p>
            <v-text-field :label="label" :placeholder="label" v-model="passNrConfirm"></v-text-field>-->
        </v-card-text>
    </form-container>
</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import {db} from "../../../services/db";
    import {CloudStorageHandler} from "../../../services/storage/cloudStorageHandler";

    export default {
        components: {FormContainer},
        name: "spieler-delete",
        props: ['action', 'actionObject'],
        data: () => ({
            passNrConfirm: '',
            spielerActions: [],
        }),
        /*computed: {
            label(){ return 'Passnummer bestätigen: ' + this.actionObject.spieler.passNr},
        },*/
        methods: {
            async save(){
                    let snack = {text: 'Das Mitglied wurde erfolgreich gelöscht!', color: 'success'};
                // get spieler actions
                    let spielerId = this.actionObject.search_spieler;
                    await this.getSpielerActions(spielerId);
                // 0. delete img
                    if ( this.actionObject.local.spieler.url ) {
                        const cloudStorageHandler = new CloudStorageHandler();
                        await cloudStorageHandler.deleteFile('/passfotos/' + spielerId + '.jpeg');
                    }
                // 1. delete spieler
                    db.collection("spieler").doc(spielerId)
                        .delete().then(() => {
                            this.$emit('actionSnack', snack);
                    // 2. delete private data
                            db.collection("spieler/" + spielerId + "/private").doc(spielerId)
                                .delete().then(() => {}).catch((error) => {
                                console.error("Error removing document A: ", error);
                            });
                    // 3. delete spieler actions
                            this.spielerActions.forEach( (spielerAction) => {
                                console.log ("spielerActionID: ", spielerAction.id);
                                db.collection("spieler_actions").doc(spielerAction.id)
                                    .delete().then(() => {}).catch((error) => {
                                    console.error("Error removing document B: ", error);
                                });
                            });
                        })
                // handle error in spieler deletion
                        .catch((error) => {
                            snack = {text: 'Beim Löschen ist ein Fehler aufgetreten!', color: 'error'};
                            this.$emit('actionSnack', snack);
                        // close
                            console.error("Error removing document C: ", error);
                        });
                // close immediately
                    window.history.back();
            },
            async getSpielerActions(spielerId) {
                this.spielerActions = [];
                let params = {
                    collection: 'spieler_actions',
                    queryField: 'search_spieler',
                    queryOperator: '==',
                    queryValue: spielerId,
                };
                let reply = await this.$store.dispatch('getTempSnapshotList', params);
                if ( reply.successful ) {
                    this.spielerActions = reply.content;
                }
            },
        },
    }
</script>

<style scoped>

</style>